window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => {
    const newColorScheme = e.matches ? "dark" : "light";
});

if (!Cookies('isDarkMode') && !Cookies('disabledDarkMode')) {
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        jQuery('body').addClass('dark-mode');
        jQuery('.toggle-mode').addClass('toggle-mode--active');
        jQuery('.toggle-ios').prop('checked', true);
        Cookies.set('isDarkMode', 'true', {expires: 7});
    }
}

jQuery(document).ready(function ($) {
    let darkmode = Cookies('isDarkMode');
    if (typeof darkmode == 'undefined') {
        darkmode = false;
    }

    if (darkmode == 'true') {
        $('body').addClass('dark-mode');
        $('.toggle-mode').addClass('toggle-mode--active');
        $('.toggle-ios').prop('checked', true);
    }

    $('.toggle-mode').on('click', function (event) {
        event.preventDefault();

        if (darkmode === 'true' || darkmode === true) {
            darkmode = false;
            $('body').removeClass('dark-mode');
            $('.toggle-mode').removeClass('toggle-mode--active');
            $('.toggle-ios').prop('checked', darkmode);
            Cookies.remove('isDarkMode');
            Cookies.set('disabledDarkMode', 'true', {expires: 7});
            return;
        }

        if (darkmode === 'false' || darkmode === false) {
            darkmode = true;
            $('body').addClass('dark-mode');
            $('.toggle-mode').addClass('toggle-mode--active');
            $('.toggle-ios').prop('checked', darkmode);
            Cookies.remove('disabledDarkMode');
            Cookies.set('isDarkMode', 'true', {expires: 7});
            return;
        }
    });
});
